<template>
  <CollapsibleCard
    :value="true"
    collapsibleIcon="mdi-upload"
    collapsibleTitle="Vedlegg"
    :padding="true"
  >
    <template v-slot>
      <Attachments v-model="value"></Attachments>
    </template>
  </CollapsibleCard>
</template>

<script lang="ts">
import Vue from "vue";
import CollapsibleCard from "@/components/shared/cards/CollapsibleCard.vue";
import Attachments from "@/components/shared/attachments/Attachments.vue";

export default Vue.extend({
  name: "AberrationAttachmentsCard",
  props: {
    value: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      dataTest: [],
    };
  },
  components: {
    CollapsibleCard,
    Attachments,
  },
});
</script>
